import React from "react";
import { useNavigate } from "react-router-dom";
import {
    Form,
    Modal,
    Typography,
    Button,
    Select,
    notification,
} from "antd";
// import RuntimeConfigsApi from "../../Apis/RuntimeConfigsApi";

const { Title } = Typography;
function AddCurrencyConfigurations({ visible, onClose }) {
    const [formAdd] = Form.useForm();
    const navigate = useNavigate
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

    const handleSubmit = (data) => {
        let formData = JSON.stringify({
            configType: "CURRENCY_TYPE_CONFIG",
            runtimeConfigList: [{
                configKey: "CURRENCY_TYPE",
                configValue: data?.currency
            }],

            tenantDTO: {
                id: decodedToken?.tenantId,
                tenantApiKey: decodedToken?.tenantApiKey,
            },
        })

        // RuntimeConfigsApi.CreateRuntimeConfigs(formData)
        //     .then((response) => {
        //         notification.open({
        //             message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
        //             description: "Update Successfully",
        //             closeIcon: false,
        //             duration: 3,
        //             style: {
        //                 backgroundColor: "#b3ffb3",
        //                 color: "green",
        //             },
        //         });
        //         setTimeout(() => {
        //             window.location.reload();
        //         }, 500);
        //     })
        //     .catch((err) => {
        //         if (err.apiError.status) {
        //             notification.open({
        //                 message: <span style={{ fontWeight: "bold" }}>Error</span>,
        //                 description: err.apiError.message,
        //                 closeIcon: false,
        //                 duration: 3,
        //                 style: {
        //                     backgroundColor: "#fff2f0",
        //                     color: "red",
        //                 },
        //             });
        //         }
        //     });
    }


    const handleCancel = () => {
        formAdd.resetFields();
        onClose();
    };
    const validateInputNumber = (_, value) => {
        if (value >= 0) {
            return Promise.resolve();
        }
        return Promise.reject(new Error("Value must be greater than to 0"));
    };

    return (
        <>
            <Modal
                footer={[]}
                width={450}
                visible={visible}
                closable={false}
                maskClosable={false}
                onCancel={handleCancel}
                onOk={onClose}
            >
                <Title level={4} className="text-center Primary-Font">
                    Set Default Currency
                </Title>
                <p className="mb-3  pb-1 text-center">You have not set up the system default currency yet. Please set the currency bellow</p>
                <Form
                    form={formAdd}
                    name="nest-messages"
                    layout="horizontal"                    
                    wrapperCol={{
                        span: 24,
                    }}
                    className="FormClass IndividualProduct-Model"
                    onFinish={handleSubmit}
                >
                    <>
                        <Form.Item
                            name="currency"
                            className="text-lable disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Currency ",
                                },
                            ]}
                        >
                            <Select
                                className="control-Select"
                                placeholder="Select Currency"
                            >
                                <option value="€"> Euro</option>
                                <option value="$"> Dollar</option>
                            </Select>
                        </Form.Item>


                        <div className="d-flex justify-content-center pt-2">
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="btn btn-primary btn-save mx-2"
                                style={{ width: "37%" }}
                            >
                                Save
                            </Button>

                        </div>
                    </>
                </Form>
            </Modal>
        </>
    );
}

export default AddCurrencyConfigurations;
